import IcFile from "../../../assets/file.png";
import { Paper } from "@mui/material";
import React from "react";

interface ISummaryCardProps {
  title: string;
  subTitle: string;
  onDownload?: () => void;
  children: React.ReactNode;
}

const SummaryCard: React.FC<ISummaryCardProps> = ({
  title,
  subTitle,
  onDownload,
  children,
}) => {

  return (
    <Paper elevation={0} className='panel'>
      <div className='panel-header'>
        <div className='row'>
          <img src={IcFile} alt="" />
          <label className='panel-title'>{title}</label>
        </div>
        <button onClick={onDownload} className='download'>
          Download
        </button>
      </div>
      <div className='separator' />
      <div className='panel-body'>
        <h3 className='subtitle'>{subTitle}</h3>
        {children}
      </div>
    </Paper>
  );
};

export default SummaryCard;
/*
const browserStyles = makeStyles(() =>
  createStyles({
    panel: {
      borderRadius: 15,
      marginBottom: 16,
      backgroundColor: "#FFFFFF",
    },
    panelHeader: {
      height: 100,
      padding: 36,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    panelTitle: {
      fontSize: 16,
      marginLeft: 16,
    },
    panelBody: {
      padding: 32,
    },
    seperator: {
      height: 1,
      marginLeft: 46,
      marginRight: 46,
      backgroundColor: "#f1f1f1",
    },
    row: {
      display: "flex",
      alignItems: "center",
    },
    subTitle: {
      color: "#6A8487",
    },
    download: {
      textDecoration: "underline",
      fontWeight: "bold",
      fontSize: 16,
      lineHeight: "20px",
      color: "#000000",
      background: "none",
      border: "none",
      marginRight: 8,
      cursor: "pointer",
    },
  })
);
*/